// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let ReportGroupRequestMessage = function (fieldSet)
{
    this.Code = Message.CODE_REPORT_GROUP_REQUEST;
    PFixMessage.call(this, fieldSet);
}
ReportGroupRequestMessage.prototype = Object.create(PFixMessage.prototype);


ReportGroupRequestMessage.prototype.setReportId = function (id)
{
    this.setFieldValue(FieldsFactory.FIELD_REPORT_ID, id);
}

ReportGroupRequestMessage.prototype.setLanguage = function (language)
{
    this.setFieldValue(FieldsFactory.FIELD_LANG, language);
}

ReportGroupRequestMessage.prototype.setIsTechnicalReport = function (isTechnical)
{
    this.setFieldValue(FieldsFactory.FIELD_IS_TECHNICAL_REPORT, isTechnical);
}